import { Component, Input } from '@angular/core';

@Component({
  selector: 'prg-when-then-tile,[prg-when-then-tile]',
  template: '<span class="tile clickable" prg-when-then-tile [item]="item"></span>'
})
export class WhenThenTileComponent {

  @Input() item: any;
}




// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/when-then-tile/when-then-tile.component.ts